


  import dep0 from "@ember/test-waiters/-embroider-implicit-modules.js";
  import dep1 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep2 from "ember-modifier/-embroider-implicit-modules.js";
  import dep3 from "reactiveweb/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
  {
  }
);
